<template>
  <div>
    <vxe-table
      border
      resizable
      show-overflow
      :max-height="$store.state.app.tableHeight"
      :data="tableData"
      size="mini"
      ref="ruleTable"
      :columns="columnList"
      :valid-config="{ autoPos: true, message: 'inline' }"
      align="center"
      :show-footer="true"
      :footer-method="footerMethodTotal"
      auto-resize
    >
      <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
      <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>

      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :type="item.type"
        :visible="item.visible"
        :fixed="item.fixed"
        :width="item.width || 120"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
      >
        <template slot-scope="scope">
          <span v-if="item.dictType">
            {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
          </span>
          <span v-else-if="item.options">
            {{ item.options[scope.row[item.field]] }}
          </span>
          <span v-else>{{ scope.row[item.field] }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';

  export default {
    props: {},
    components: {},
    data() {
      return {
        footerTotalCols: {
          amount: [],
        },
        tableData: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      maxHeight() {
        return window.innerHeight / 2 + 'px';
      },

      columnList() {
        return [
          // { type: 'checkbox', width: 50 },
          // {
          //   title: this.$t('financeSalesInvoiceDetail.column.sortNo'),
          //   field: 'sortNo',
          //   type: 'seq',
          //   width: 60,
          // }, //序号
          {
            field: 'invoiceInfoCompanyName',
            title: '公司名称',
            width: 150,
          },
          {
            field: 'invoiceInfoDepartmentName',
            title: '部门',
            width: 150,
          },
          {
            field: 'invoicedApplicationNumber',
            title: '开票申请编号',
            width: 150,
          },
          {
            field: 'invoicedApplicationLineNumber',
            title: '开票申请行号',
            width: 150,
          },
          {
            field: 'invoicedApplyAmount',
            title: '开票申请金额（含税）',
            width: 150,
          },
          {
            field: 'invoicedApplyTax',
            title: '开票申请税额',
            width: 150,
          },
          {
            field: 'receiptBillUserName',
            title: '收票人',
            width: 150,
          },
          {
            field: 'invoiceDate',
            title: '开票日期',
            width: 150,
          },
          {
            field: 'invoicedAmount',
            title: '开票金额（含税）',
            width: 150,
          },
          {
            field: 'invoicedTax',
            title: '开票税额',
            width: 150,
          },

          {
            field: 'goldenInvoiceCode',
            title: '金税发票代码',
            width: 150,
          },
          {
            field: 'goldenInvoiceNumber',
            title: '金税发票编号',
            width: 150,
          },
          {
            field: 'goldenInvoiceStatus',
            title: '金税发票状态',
            options: {
              0: '未申请',
              1: '部分申请',
              2: '已申请',
              6: '已作废',
            },
            width: 150,
          },
          {
            field: 'goldenInvoicePostDate',
            title: '发票入账日期',
            width: 150,
          },
          {
            field: 'redInvoiceNumber',
            title: '红字发票编号',
            width: 150,
          },
          {
            field: 'redWashDate',
            title: '红冲日期',
            width: 150,
          },
          {
            field: 'invalidDate',
            title: '作废日期',
            width: 150,
          },
        ];
      },
    },
    mounted() {},
    watch: {},
    methods: {
      footerMethodTotal({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = XEUtils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = XEUtils.commafy(XEUtils.toNumber(total).toFixed(point), point);
                return total;
              }
            }
          }),
        ];
      },
    },
  };
</script>
<style lang="scss" scoped>
  .price-col {
    line-height: 18px;
  }
</style>
